import { useContext } from 'react';

import { AdminContext } from '../../contexts/admin.context';

import Button from './Button';
import Spinner from './Spinner';
import { DownloadIconWithBar } from '../icons';

export const DownloadButton = ({
  onClick,
  isLoading = false,
  buttonType = 'outline',
  bg = '',
  color = '',
  extraClass = '',
  downloadIconClass = '',
  children
}) => {
  const { themeConfig: { primary } = {} } = useContext(AdminContext);

  return (
    <Button
      type="button"
      buttonType={buttonType}
      bg={bg}
      color={color}
      onClick={onClick}
      extraClass={extraClass}>
      {isLoading ? (
        <span className="flex gap-2 items-center">
          {typeof isLoading !== 'boolean' && !isNaN(isLoading) && (
            <span
              className="block w-32 h-4 rounded-lg border p-1 bg-white"
              style={{
                borderColor: color ? color : buttonType === 'primary' ? '#fff' : primary
              }}>
              <span
                className="block h-full rounded-lg bg-white"
                style={{
                  width: `${isLoading}%`,
                  backgroundColor: color ? color : primary
                }}
              />
            </span>
          )}
          <Spinner size={16} color={color ? color : buttonType === 'primary' ? '#fff' : primary} />
        </span>
      ) : (
        <span className="flex gap-2 items-center">
          {children}
          <DownloadIconWithBar
            color={color ? color : buttonType === 'primary' ? '#fff' : primary}
            className={downloadIconClass}
          />
        </span>
      )}
    </Button>
  );
};
